import { Modal } from 'antd';
import { P } from '../../theme/tokens';
import StatusPill from '../StatusPill';
import { CLOSE_ICON, CLOSE_ICON_LG, ModalTitle } from './shared';
import { Block, Facts, HeadRow, HeadTools, MODAL_STYLES } from './styled';

const PILL_STYLE = { background: P.white };

const STACK = { display: 'grid', gap: 14 };

const mergeStyles = (styles) =>
  Object.fromEntries(Object.keys({ ...MODAL_STYLES, ...styles }).map((k) => [k, { ...MODAL_STYLES[k], ...styles[k] }]));

export function FactsBlock({ facts, lead, children }) {
  const shown = facts.filter((f) => f.value);
  const extra = lead || children;
  if (!shown.length && !extra) return null;
  return (
    <Block style={extra ? STACK : undefined}>
      {lead}
      {shown.length > 0 && (
        <Facts>
          {shown.map((f) => (
            <div key={f.label} style={{ display: 'contents' }}>
              <dt>{f.label}</dt>
              <dd>{f.value}</dd>
            </div>
          ))}
        </Facts>
      )}
      {children}
    </Block>
  );
}

export default function DetailModal({
  title,
  subtitle,
  eyebrow,
  titleSize,
  status,
  actions,
  footer = null,
  width = 520,
  top = 88,
  styles,
  onClose,
  children
}) {
  const head = <ModalTitle title={title} subtitle={subtitle} eyebrow={eyebrow} size={titleSize} />;
  return (
    <Modal
      open
      onCancel={onClose}
      width={width}
      style={{ top, paddingBottom: 0 }}
      styles={styles ? mergeStyles(styles) : MODAL_STYLES}
      closeIcon={titleSize ? CLOSE_ICON_LG : CLOSE_ICON}
      title={
        status || actions ? (
          <HeadRow>
            {head}
            <HeadTools>
              {status && <StatusPill color={status.color} style={PILL_STYLE}>{status.label}</StatusPill>}
              {actions}
            </HeadTools>
          </HeadRow>
        ) : (
          head
        )
      }
      footer={footer}
    >
      {children}
    </Modal>
  );
}
